import { useEffect, useState } from "react";
import { useKpiData } from "utils/samarth-dashboard-context/hooks/useKpiData";
import WidgetWrapper from "../widget-wrapper/widget-wrapper";
import ChartSkeleton from "../../ui/chart-skeleton/chart-skeleton";
import SingleLineCharts from "../../ui/SinglelineCharts/singlelineCharts";
import SingleTabTable from "../../ui/SingleTabTable";
import { useSamarthDashboardContext } from "utils/samarth-dashboard-context/hooks/useSamarthDashboardContext";
import styles from "../maiWidgets/mai-widget.module.css"

const SalesIndexWidget = () => {
  const { state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const chartData = state.dashboardData.salesIndex;
  const loader = state.dashboardData.isLoading.salesIndex;
  const { filters } = useKpiData();

  const [isOn, setIsOn] = useState(true);
  const [isPopup, setIsPopup] = useState(false);
  const [currentTDPData, setCurrentTDPData] = useState(chartData);

  useEffect(() => {
    const sourceKey = isOn ? 'abs' : 'percentage';
    const selectedTDP = filters.tdp;
    const hasActionFilters = !!filters.actionFilters;

    if (hasActionFilters && chartData[0]?.[selectedTDP]) {
      const selectedData = chartData[0][selectedTDP].map((item) => ({
        ...item,
        value: isOn ? item.value : item.percentage || 0,
      }));
      setCurrentTDPData(selectedData);
    } else {
      const dataset = chartData[sourceKey];
      if (Array.isArray(dataset) && dataset.length > 0) {
        const transformed = dataset.map((item) => ({
          ...item,
          value: item.value || 0,
        }));
        setCurrentTDPData(transformed);
      } else {
        setCurrentTDPData([]);
      }
    }
  }, [chartData, filters.tdp, filters.actionFilters, isOn]);

  const displayData = currentTDPData;

  return (
    <WidgetWrapper
      title="Sales Index"
      showBlueDot
      isOn={isOn}
      setIsOn={setIsOn}
      isTableView={globalViewMode === 'table'}
      isDialogOpen={isPopup}
      setIsDialogOpen={setIsPopup}
      toogleLables={['%', 'abs']}
      infoText="Sales Index measures actual sales to forecasted sales (in Tonnes)"
    >
      {loader ? (
        <div style={{ width: '100%', height: '100%' }}>
          <ChartSkeleton isOn={isPopup} />
        </div>
      ) : (
        <div style={{ height: '100%', paddingLeft: '12px' }}>
          {globalViewMode === 'graph' ? (
            <SingleLineCharts
              dataKey="week"
              left={isOn ? 20 : 0}
              valueKey="value"
              data={displayData}
              nearest5
              tickFormatter={isOn ? '' : '%'}
              isExpansionNeeded
              tooltipFormatter={(value) => {
                const num = Number(value);
                if (num >= 100000) return `${(num / 100000).toFixed(2)}L`;
                if (num >= 1000) return `${(num / 1000).toFixed(2)}K`;
                return num.toString();
              }}
            />
          ) : (
            <SingleTabTable
              data={displayData}
              keys={['week', 'value']}
              colorLogic={(key, value) => {
                if (value >= 60) return styles.textGreen;
                if (value >= 50) return styles.textYellow;
                if (value >= 30) return styles.textPink;
                return styles.textRed;
              }}
            />
          )}
        </div>
      )}
    </WidgetWrapper>
  );
};

export default SalesIndexWidget;
